import "./Facilities.css";

import {
  FaSolarPanel,
  FaRobot,
  FaLaptopCode,
  FaBookOpen,
  FaBus,
  FaHospital,
  FaDesktop,
} from "react-icons/fa";

import { MdOutlineVideocam, MdSportsCricket } from "react-icons/md";

function Facilities() {
  const facilities = [
    {
      icon: <FaSolarPanel />,
      title: "Solar Power System",
      description:
        "Eco-friendly solar energy system ensuring sustainable operations.",
    },

    {
      icon: <MdOutlineVideocam />,
      title: "CCTV Surveillance",
      description:
        "24×7 CCTV monitoring for student safety and campus security.",
    },

    {
      icon: <FaRobot />,
      title: "Robotics & AI Lab",
      description:
        "Hands-on learning with robotics, coding and artificial intelligence.",
    },

    {
      icon: <MdSportsCricket />,
      title: "Sports Ground",
      description:
        "Large playground supporting sports and physical development.",
    },

    {
      icon: <FaLaptopCode />,
      title: "Fully Digitised Operations",
      description: "Technology-driven administration and communication system.",
    },

    {
      icon: <FaBookOpen />,
      title: "24×7 Library",
      description: "Extensive collection of books and learning resources.",
    },

    {
      icon: <FaBus />,
      title: "Transport Facility",
      description: "Safe and reliable transportation covering nearby areas.",
    },

    {
      icon: <FaHospital />,
      title: "Medical Room",
      description: "First-aid and healthcare support available on campus.",
    },

    {
      icon: <FaDesktop />,
      title: "Computer Lab",
      description: "Modern computer lab with latest hardware and software.",
    },
  ];

  return (
    <section className="facilities-section">
      <div className="container">
        <div className="text-center mb-5">
          <h3 className="facilities-title">
            Our <span>Facilities</span>
          </h3>

          <p className="facilities-subtitle">
            Providing world-class infrastructure and modern facilities to
            support holistic learning and development.
          </p>
        </div>

        <div className="facilities-grid">
          {facilities.map((item, index) => (
            <div key={index} className="facility-card">
              <div className="facility-icon">{item.icon}</div>

              <h4>{item.title}</h4>

              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Facilities;
